import { render, staticRenderFns } from "./AddDashboard.vue?vue&type=template&id=49157a6c&scoped=true&"
import script from "./AddDashboard.vue?vue&type=script&lang=js&"
export * from "./AddDashboard.vue?vue&type=script&lang=js&"
import style0 from "./AddDashboard.vue?vue&type=style&index=0&id=49157a6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49157a6c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/acarmichael/Desktop/DEV/BOSS40-FrontEnd/boss-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VChip } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VAutocomplete,VBtn,VCard,VChip,VFlex,VForm,VIcon,VLayout})
